import { UIHeading3, UIText1 } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';
import { PriceDiscount } from 'shared/components/PriceDiscount';

import * as styles from './BookedOfferRecommendationItem.css';
import { Underground } from './Underground';
import { IRecomendedOfferSchema } from '../../../types/recommendedOffer';

export interface IBookedOfferRecommendationItemProps {
  offer: IRecomendedOfferSchema;
  position: number;
  onClick: (offer: IRecomendedOfferSchema, position: number) => void;
}

export const BookedOfferRecommendationItem = ({ offer, position, onClick }: IBookedOfferRecommendationItemProps) => {
  const { title, address, underground, photoUrl, url, discount, price, oldPrice, newbuildingName } = offer;

  const showOneAddressRow = Boolean(discount && underground?.name);
  const showTwoAddressRows = Boolean((discount && !underground?.name) || (!discount && underground?.name));

  const handleClick = () => {
    onClick(offer, position);
  };

  return (
    <div className={styles['item']}>
      <a href={url} className={styles['link']} onClick={handleClick} target="_blank" rel="noreferrer">
        <div className={styles['image-container']}>
          <img src={photoUrl} alt={title} className={styles['image']} />
        </div>

        <div className={styles['content']}>
          <div className={styles['price-container']}>
            <UIHeading3>{price}</UIHeading3>
            {oldPrice && discount && <PriceDiscount oldPrice={oldPrice} percent={discount} />}
          </div>

          <div className={styles['ellipsis']}>
            <UIText1 display="inline">{title}</UIText1>
          </div>
          {underground && <Underground underground={underground} />}
          {address && (
            <div
              className={clsx(
                styles['address'],
                showOneAddressRow && styles['address_one_row'],
                showTwoAddressRows && styles['address_two_rows'],
              )}
            >
              {newbuildingName}, {address}
            </div>
          )}
        </div>
      </a>
    </div>
  );
};
